import React from 'react';
import { Reveal } from './Reveal';
const highlights: [string, string][] = [['360', 'Pages of curriculum'], ['144', 'Ready-to-run lessons'], ['100%', 'Classroom and court ready']];
export function TransformationSection() {
  return <section className="bg-tr-cream px-5 py-14 md:py-24" data-id="element-192" data-mp="2wvsxayk2aina">
      <Reveal className="mx-auto max-w-container text-center" data-id="element-193" data-mp="2rzc9y6kos8b9">
        <p className="mb-4 text-[11px] font-semibold uppercase tracking-[0.22em] text-tr-grey/70" data-id="element-194" data-mp="2s0x1dnbpfb4w">
          A Better Way to Teach Tennis
        </p>
        <h2 className="mx-auto max-w-3xl text-[1.9rem] font-bold leading-[1.12] tracking-tight text-tr-navy sm:text-4xl md:text-[2.9rem]" data-id="element-195" data-mp="2j57knrl7b4xu">
          From an Overwhelmed Coach to a
          <br className="hidden sm:block" data-id="element-196" data-mp="298uj67jezmsj" />{' '}
          <span className="font-accent italic text-tr-navy" data-id="element-197" data-mp="295ykui3nmw3k">
            Confident Tennis Guide.
          </span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-[15px] leading-relaxed text-tr-grey md:text-base" data-id="element-198" data-mp="207d48shqtr5f">
          Tennis Ready turns hours of planning into an open-and-teach system.
          Every drill, every progression, every assessment is already written,
          sequenced and tested on court.
        </p>
        <div className="mx-auto mt-10 grid max-w-2xl divide-y divide-tr-border overflow-hidden rounded-card border border-tr-border bg-white shadow-card sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-199" data-mp="5d670b3z2sdy">
          {highlights.map(([value, caption]) => <div key={caption} className="px-5 py-5" data-id="element-200" data-mp="y23jtypezwzb">
              <strong className="block text-2xl font-bold leading-none text-tr-navy" data-id="element-201" data-mp="1316kz829xj20">
                {value}
              </strong>
              <span className="mt-2 block text-[10px] font-semibold uppercase tracking-[0.14em] text-tr-grey/80" data-id="element-202" data-mp="p040v0uuaitq">
                {caption}
              </span>
            </div>)}
        </div>
      </Reveal>
    </section>;
}